import { AxiosResponse } from 'axios'
import { Moment } from 'moment'

import ClientSDK from '../../../../App/ClientSDK'
import { DATE_STANDARD_FORMAT } from '../../../../App/DateFormats'

import { IAPIBestSold, IBestSold } from './IBestSold'
import Transformer from './Transformer'

export class Client {
    static getTopSoldProducts = (
        from: Moment,
        to: Moment
    ): Promise<IBestSold[]> => {
        const startAt = from.format(DATE_STANDARD_FORMAT)
        const endsAt = to.format(DATE_STANDARD_FORMAT)

        return ClientSDK.instance()
            .get(`report/dashboard/top-products/${startAt}/${endsAt}`)
            .then((response: AxiosResponse<IAPIBestSold[]>): IBestSold[] => {
                return Transformer.transform(response.data)
            })
    }
}
